<div>
<ul class="list-group list-group-flush" style="width: 17.5%;">
  @for (m of menu; track m) {
  <a class="list-group-item" [class.active]="currentTab==m?.urlParentPath" [routerLink]="['/'+m?.link]"
    [attr.tittle]="m?.title" [queryParams]="m?.queryParams"><i [attr.class]="m?.icon"></i><span>{{m?.title}}</span></a>
  }
  <hr class="divider" />
</ul>
</div>
<!-- afterChangeView -->
